import { Modal } from "react-bootstrap";
import Popup from "../../Helpers/Popup/Popup";
import PopupTitle from "../../Helpers/Popup/PopupParts/PopupTitle";
import {
	useGetSpecificRequestQuery,
	useGetServiceRequestTasksQuery,
} from "../../../Redux/service/Requests/Request";
import { Tag, Segmented } from "antd";
import trans from "../../../utils";
import Close from "../../Helpers/CloseBtn/Close";
import Loader from "../../Helpers/Loader/Loader";
import ViewRequestBody from "./ViewRequestBody";
import RequestActivityHistory from "./RequestActivityHistory";
import ServiceRequestTasksTab from "./ServiceRequestTasksTab";
import { TaskPopup } from "../../Tasks/Popups/TaskPopup";
import { useContext, useState } from "react";
import { popupcontext } from "../../../context/Popupscontext";

const ViewRequest = ({ requestId }) => {
	const { handleClose } = useContext(popupcontext);
	const { data, isFetching } = useGetSpecificRequestQuery(requestId, {
		skip: !requestId,
		refetchOnMountOrArgChange: true,
	});
	const { data: tasksData, isFetching: isFetchingTasks } = useGetServiceRequestTasksQuery(
		requestId,
		{ skip: !requestId, refetchOnMountOrArgChange: true },
	);
	const tasks = tasksData?.data || [];
	const [selectedTaskId, setSelectedTaskId] = useState(null);
  const statusColors = {
    inProgress: `blue`,
    pending: `orange`,
    completed: `green`,
    cancelled: `red`,
    none: `default`,
    Assigned: `purple`,
  };
	const request = data?.data || "";
	const [activeTab, setActiveTab] = useState("info");
	return (
		<Popup show={!!requestId} size={"lg"}>
			<Modal.Header className="modal-header flex-between">
				<Modal.Title id="contained-modal-title-vcenter">
					<PopupTitle
						headtitle={
							<div>
								{request?.code
									? `${trans("Request Number")} : ${request.code}`
									: "Loading..."}{" "}
								{!isFetching && request?.status && (
									<Tag
										color={statusColors[request.status] || statusColors.none}
										className="text-capitalize"
									>
										{trans(request.status)}
									</Tag>
								)}
							</div>
						}
					/>
				</Modal.Title>
				<Close
					// eslint-disable-next-line react/style-prop-object
					style="close-32 close"
					close={() => handleClose("display")}
					img="Close"
				/>
			</Modal.Header>
			<Modal.Body className="modal-body-scrollable fixed-popup-height">
				{isFetching ? (
					<div className="loader-container">
						<Loader />
					</div>
				) : (
					<>
						<Segmented
							block
							className="mb-3"
							value={activeTab}
							onChange={setActiveTab}
							options={[
								{ label: trans("Request Information"), value: "info" },
								{ label: trans("Activity History"), value: "history" },
								{
									label: `${trans("Tasks")}${tasks.length ? ` (${tasks.length})` : ""}`,
									value: "tasks",
								},
							]}
						/>
						{activeTab === "info" && <ViewRequestBody data={request} />}
						{activeTab === "history" && (
							<RequestActivityHistory requestId={requestId} />
						)}
						{activeTab === "tasks" && (
							<ServiceRequestTasksTab
								tasks={tasks}
								loading={isFetchingTasks}
								onSelectTask={setSelectedTaskId}
							/>
						)}
					</>
				)}
			</Modal.Body>
			<TaskPopup
				taskId={selectedTaskId}
				onClose={() => setSelectedTaskId(null)}
				zIndex={1200}
			/>
		</Popup>
	);
};

export default ViewRequest;
